module.exports = __webpack_public_path__ + "static/media/default-project.95d3dc45.jpg";